(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ayAGx", function(module, exports) {
const $01fbc4472ce060e0$var$commentSections = document.querySelectorAll(".s-comment");
$01fbc4472ce060e0$var$commentSections.forEach((section)=>{
    const comments = section.querySelectorAll(".i-comment");
    const form = section.querySelector(".f-comment");
    if (!form) return;
    const replyIdInput = form.querySelector(".f-comment__reply-id");
    const replyMsgWrapper = form.querySelector(".f-comment__reply");
    const replyMsg = replyMsgWrapper?.querySelector(".f-comment__reply-msg");
    const replyCancelReply = form.querySelector(".f-comment__cancel-reply");
    const sortSelect = section.querySelector(".s-comment__sort select");
    sortSelect?.addEventListener("change", ()=>{
        const sort = sortSelect.selectedOptions[0]?.dataset.sortBy;
        section.querySelector(".g-comment")?.classList.toggle("--reverse", sort == "DESC");
    });
    replyCancelReply?.addEventListener("click", ()=>{
        if (replyIdInput) replyIdInput.value = "";
        if (replyMsgWrapper) {
            if (replyMsg) replyMsg.innerHTML = "";
            replyMsgWrapper.classList.remove("--show");
        }
    });
    comments.forEach((comment)=>{
        const id = comment.id;
        if (!id) return;
        const replyButton = comment.querySelector(".i-comment__reply-button");
        const commentMessage = comment.querySelector(".i-comment__content")?.innerHTML;
        replyButton?.addEventListener("click", ()=>{
            if (replyIdInput) replyIdInput.value = id;
            if (replyMsgWrapper && commentMessage) {
                if (replyMsg) replyMsg.innerHTML = commentMessage;
                replyMsgWrapper.classList.add("--show");
            }
            form.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
    });
});

});

})();
//# sourceMappingURL=comment-section.41b5a4af.js.map
